import {
  UserCreateRequestType,
  UserCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { auth } from "../../../useFirebaseUser.shared";
import type { ExtendedFirebaseUser } from "../../../useFirebaseUser.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useUserCreate = (user: ExtendedFirebaseUser | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    networkMode: "always",
    retry: false,
    mutationFn: (data: UserCreateRequestType) =>
      apiV2Request({
        timeout: 15000,
        user,
        business: null,
        method: "post",
        path: `users`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as UserCreateResponseType,
      ),

    onSuccess: (data) => {
      if (auth.currentUser !== user?.firebaseUser) return;
      queryClient.setQueryData([ServerStateKeys.SellarUser], data);
    },
  });
};
